import React, { useMemo } from 'react';
import { v1 as uuid } from 'uuid';
import { CheckSymbol } from 'ui/common/check-symbol';

import styles from './list-item-checkbox.scss';

interface ListItemCheckbox {
  id: number;
  checked: boolean;
  onChange: React.ChangeEventHandler;
}

export const ListItemCheckbox: React.FC<ListItemCheckbox> = ({
  id, checked, onChange
}) => {

  const componentId = useMemo(
    () => `checkbox-${id}-${uuid()}`,
    [id]
  );

  const onClick: React.MouseEventHandler = (event) => {
    event.stopPropagation();
  };

  return <div className={styles.wrapper} onClick={onClick}>
    <input id={componentId}
      type="checkbox"
      checked={!!checked}
      onChange={onChange}
      className="visuallyhidden form-check-input" />
    <label className="label"
      htmlFor={componentId}>
      <CheckSymbol />
    </label>
  </div>;
};
